var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColoredAp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    stroke: "#500D76",
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "{stroke}",
    clipRule: "evenodd",
    d: "M15.224 6A8.724 8.724 0 0 0 6.5 14.724v10.552A8.724 8.724 0 0 0 15.224 34h10.552a8.724 8.724 0 0 0 8.724-8.724v-7.914h-2v7.914A6.724 6.724 0 0 1 25.776 32H15.224A6.724 6.724 0 0 1 8.5 25.276V14.724A6.724 6.724 0 0 1 15.224 8h7.914V6h-7.914zM16.5 19.517a4 4 0 1 1 8 0 4 4 0 0 1-8 0zm4-6a6 6 0 1 0 0 12 6 6 0 0 0 0-12zm-.139 3.79a1 1 0 0 0-1.724 1.013l2.002 3.408a1 1 0 0 0 1.724-1.013l-2.002-3.408zM30.5 7a1 1 0 1 0-2 0v3h-3a1 1 0 1 0 0 2h3v3a1 1 0 1 0 2 0v-3h3a1 1 0 1 0 0-2h-3V7z",
    fill: "#545454"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColoredAp);
export default __webpack_public_path__ + "static/media/coloredAP.84663f7ba1786618f41a1c07790a441d.svg";
export { ForwardRef as ReactComponent };